module.exports = __webpack_public_path__ + "assets/media/day30.991eb839.mp3";